import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DprPersonnelReport } from '@report/models';
import { PersonnelVersion, StaticMessage } from '@shared/enums';
import { DprPersonnel } from '@shared/models/dpr';
import {
  Personnel,
  SubprojectConfiguration,
} from '@shared/models/project-setup';
import { getStaticMessage } from '@shared/utils';

@Component({
  selector: 'app-report-personnel',
  templateUrl: './report-personnel.component.html',
  styleUrls: ['./report-personnel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPersonnelComponent implements OnInit {
  @Input({ required: true }) personnelList: Personnel[];
  @Input({ required: true }) dprPersonnel: DprPersonnel;
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;

  personnelReport: DprPersonnelReport[] = [];

  entityColName = $localize`:@@report.reportPersonnel.colEntity:Entity`;
  hoursPrShiftColName = $localize`:@@report.reportPersonnel.colHoursPrShift:Hours pr. shift`;
  manHoursCurrentDayColName = $localize`:@@report.reportPersonnel.colManHoursCurrentDay:Man-hours current day`;
  manHoursTotalToDateColName = $localize`:@@report.reportPersonnel.colManHoursTotalToDate:Man-hours total to date`;

  PersonnelVersion = PersonnelVersion;
  StaticMessage = StaticMessage;

  ngOnInit(): void {
    this.personnelList.forEach((personnel) => {
      const detail = (this.dprPersonnel.dprPersonnelDetails || []).find(
        (x) => x.personnelId === personnel.id
      );

      // TODO(Next) simplify data mapping logic
      this.personnelReport.push({
        name: personnel.name,
        previous: detail.previous,
        today: detail.today ?? '-',
        todayForTotal: detail.today,
        total: detail.previous + (detail.today ?? 0),
        workedHours: detail.workedHours?.toFixed(2) ?? '-',
        added: detail.added ?? '-',
        used: detail.used ?? '-',
        currentDay: detail.currentDay ?? '-',
        comment: detail.comment ?? '-',
        dailyStockDetails: detail.dailyStockDetails ?? {},
        workedHoursDetails: detail.workedHoursDetails ?? {},
        detail,
        isTotal: false,
      });
    });

    // don't compute total if no data
    if (!this.personnelReport.length) {
      return;
    }

    const dprPersonnelDetailTotal = {
      name: getStaticMessage(StaticMessage.TotalColumn),
      previous: 0,
      today: 0,
      total: 0,
      comment: '-',
      workedHours: '',
      added: 0,
      used: 0,
      currentDay: 0,
      dailyStockDetails: { totalStartOfDay: 0, totalEndOfDay: 0 },
      workedHoursDetails: { total: 0, totalToDate: 0 },
      isTotal: true,
    };

    this.personnelReport.forEach((item) => {
      dprPersonnelDetailTotal.previous += +item.previous;
      dprPersonnelDetailTotal.today += +item.todayForTotal;
      dprPersonnelDetailTotal.total += +item.total;
      dprPersonnelDetailTotal.added += item.detail.added ?? 0;
      dprPersonnelDetailTotal.used += item.detail.used ?? 0;
      dprPersonnelDetailTotal.dailyStockDetails.totalStartOfDay +=
        item.dailyStockDetails.totalStartOfDay ?? 0;
      dprPersonnelDetailTotal.dailyStockDetails.totalEndOfDay +=
        item.dailyStockDetails.totalEndOfDay ?? 0;
      dprPersonnelDetailTotal.workedHoursDetails.total +=
        item.workedHoursDetails.total ?? 0;
      dprPersonnelDetailTotal.workedHoursDetails.totalToDate +=
        item.workedHoursDetails.totalToDate ?? 0;
      dprPersonnelDetailTotal.currentDay += !isNaN(+item.currentDay)
        ? +item.currentDay
        : 0;
    });

    this.personnelReport.push(dprPersonnelDetailTotal);
  }
}
